import DOMPurify from 'isomorphic-dompurify';

const FORBID_TAGS = ['iframe', 'object', 'embed', 'link', 'base', 'form'];
const ADD_ATTR = ['target'];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

// DOMPurify parses a bare fragment in "head" insertion mode, so a top-level <style>
// (with no enclosing element) gets treated as document head content and dropped when
// the body fragment is serialized. Wrapping in a throwaway <div> keeps it in the body.
const WRAPPER_OPEN = '<div>';
const WRAPPER_CLOSE = '</div>';

export function sanitizeHtml(html: string): string {
    const sanitized = DOMPurify.sanitize(`${WRAPPER_OPEN}${html}${WRAPPER_CLOSE}`, { FORBID_TAGS, ADD_ATTR });
    return sanitized.slice(WRAPPER_OPEN.length, -WRAPPER_CLOSE.length);
}
